<template>
  <v-container fluid>

    <v-row dense align="center" justify="space-between" no-gutters>
      <v-col cols="12" md="2" sm="12" xs="12">
        <label class="menunamestyle ml-10">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      <v-spacer/>
      <template v-if="grade >= 50">
      <v-col  cols="12" md="3" sm="12" xs="12">
        <comdialog :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
      </v-col>
      </template>
      <v-col  cols="12" md="3" sm="12" xs="12">
        <eventdialog :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
      </v-col>
      <v-col cols="12" md="3" sm="12" xs="12" >
        <optiondialog :optionname="SEARCH_OPTION_NAME" :comidx="SEARCH_COM_IDX" :eventidx="SEARCH_EVENT_IDX" @callback="optionsearchcb"></optiondialog>
      </v-col>
    </v-row>

    <v-row align="center" dense>
      <v-spacer/>
      <v-col cols="12" md="2" sm="12" xs="12">
        <v-menu
          v-model="date1"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="search_start_date"
              :label="$t('common_search_start')"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="search_start_date" @input="date1 = false" :first-day-of-week="0" :locale="$i18n.locale"></v-date-picker>
        </v-menu>      
      </v-col>
      <v-col cols="12" md="2" sm="12" xs="12">                      
        <v-menu
          v-model="date2"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="search_end_date"
              :label="$t('common_search_end')"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="search_end_date" @input="date2=false" :first-day-of-week="0" :locale="$i18n.locale"></v-date-picker>
        </v-menu>                    
      </v-col>
      <v-col cols="12" md="1" sm="6" xs="6" class="d-flex justify-center">
        <v-checkbox v-model="checkdate" dense :label="$t('chartpayment_label1')"/>
      </v-col>
      <v-col cols="12" md="2" sm="6" xs="6" class="d-flex justify-center">
        <v-btn class="search_btn" elevation="0" outlined large @click="search_run">{{$t("common_ok")}}</v-btn>
        <v-btn class="ml-2" color="#4e6ef7" large rounded @click="startDownload()"><v-icon color="white">cloud_download</v-icon></v-btn>
      </v-col>
    </v-row>

    <v-row dense justify="center">
      <v-col cols="6" md="1" style="padding:2px"> 
        <div class="chartsum_round">
          <label class="chartsum_title">{{$t('chartpayment_col1')}}</label>
          <label class="chartsum_value">{{priceToString(sum1)}}</label>
        </div>
      </v-col>
      <v-col cols="6" md="1" style="padding:2px">
        <div class="chartsum_round">
          <label class="chartsum_title">{{$t('chartpayment_col2')}}</label>
          <label class="chartsum_value">{{priceToString(sum2)}}</label>
        </div>
      </v-col>
      <v-col cols="4" md="1" style="padding:2px">
        <div class="chartsum_round">
          <label class="chartsum_title">{{$t('chartpayment_col3')+'(KRW)'}}</label>
          <label class="chartsum_value">{{priceToString(sum3)}}</label>
        </div>
      </v-col>
      <v-col cols="4" md="1" style="padding:2px">
        <div class="chartsum_round">
          <label class="chartsum_title">{{$t('chartpayment_col4')+'(KRW)'}}</label>
          <label class="chartsum_value">{{priceToString(sum4)}}</label>
        </div>
      </v-col>
      <v-col cols="4" md="1" style="padding:2px">
        <div class="chartsum_round">
          <label class="chartsum_title">{{$t('chartpayment_col5')+'(KRW)'}}</label>
          <label class="chartsum_value">{{priceToString(sum5)}}</label>
        </div>
      </v-col>
      <v-col cols="4" md="1" style="padding:2px">
        <div class="chartsum_round">
          <label class="chartsum_title">{{$t('chartpayment_col3')+'(USD)'}}</label>
          <label class="chartsum_value">{{priceToString(sum6)}}</label>
        </div>
      </v-col>
      <v-col cols="4" md="1" style="padding:2px">
        <div class="chartsum_round">
          <label class="chartsum_title">{{$t('chartpayment_col4')+'(USD)'}}</label>
          <label class="chartsum_value">{{priceToString(sum7)}}</label>
        </div>
      </v-col>
      <v-col cols="4" md="1" style="padding:2px">
        <div class="chartsum_round">
          <label class="chartsum_title">{{$t('chartpayment_col5')+'(USD)'}}</label>
          <label class="chartsum_value">{{priceToString(sum8)}}</label>
        </div>
      </v-col>
    </v-row>

    <v-row class="mt-5">
      <v-col>
        <v-simple-table 
          height="40vh"
          dense fixed-header
          class="datatablestyle"
          >
          <template v-slot:default>
            <thead style="height:48px">
              <tr>
                <th class="text-center header_text_style">{{$t('chartpayment_col6')}}</th>
                <th class="text-center header_text_style">{{$t('chartpayment_col1')}}</th>
                <th class="text-center header_text_style">{{$t('chartpayment_col2')}}</th>
                <th class="text-center header_text_style">{{$t('chartpayment_col3')+'(KRW)'}}</th>
                <th class="text-center header_text_style">{{$t('chartpayment_col4')+'(KRW)'}}</th>
                <th class="text-center header_text_style">{{$t('chartpayment_col5')+'(KRW)'}}</th>
                <th class="text-center header_text_style">{{$t('chartpayment_col3')+'(USD)'}}</th>
                <th class="text-center header_text_style">{{$t('chartpayment_col4')+'(USD)'}}</th>
                <th class="text-center header_text_style">{{$t('chartpayment_col5')+'(USD)'}}</th>
              </tr>
            </thead>
            <tbody>
              <tr style="background-color:#f0f0f0">
                <td class="text-center">{{$t('chartpayment_col7')}}</td>
                <td class="text-center">{{ priceToString(sum1) }}</td>
                <td class="text-center">{{ priceToString(sum2) }}</td>
                <td class="text-center">{{ priceToString(sum3) }}</td>
                <td class="text-center">{{ priceToString(sum4) }}</td>
                <td class="text-center">{{ priceToString(sum5) }}</td>
                <td class="text-center">{{ priceToString(sum6) }}</td>
                <td class="text-center">{{ priceToString(sum7) }}</td>
                <td class="text-center">{{ priceToString(sum8) }}</td>
              </tr>
              <tr v-for="item in list" :key="item.REG_DATE">
                <td class="text-center">{{ item.REG_DATE }}</td>
                <td class="text-center">{{ priceToString(item.CNT1) }}</td>
                <td class="text-center">{{ priceToString(item.CNT2) }}</td>
                <td class="text-center">{{ priceToString(item.COST1) }}</td>
                <td class="text-center">{{ priceToString(item.COST2) }}</td>
                <td class="text-center">{{ priceToString(item.COST3) }}</td>
                <td class="text-center">{{ priceToString(item.COST_USD1) }}</td>
                <td class="text-center">{{ priceToString(item.COST_USD2) }}</td>
                <td class="text-center">{{ priceToString(item.COST_USD3) }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>

    <!-- 
    <v-row justify="center">
      <v-col cols="10">
        <canvas ref="drawarea" style="width:95%"/>
      </v-col>
    </v-row>
    -->

  </v-container>
</template>
<script>


import moment from 'moment'
import XLSX from 'xlsx'
export default {


  beforeDestroy(){
    
    //차트 초기화 - 제대로 안지우면 인스턴스 계속 쌓인다.
    if(this.myChart2 != null){
      this.myChart2.destroy();
    }
  },

  mounted(){

    if(this.$session.get("GRADE") < 10){
      this.$alert(this.$t("common_nograde"));
      this.$router.push("Login");
      return;
    }

    this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
    this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
    this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
    this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
    this.SEARCH_OPTION_IDX  = this.$session.get("OPTION_IDX");
    this.SEARCH_OPTION_NAME = this.$session.get("OPTION_NAME");
    this.grade = this.$session.get("GRADE");
    
    this.search_start_date  = this.$session.get("EVENT_START");
    if(this.search_start_date == null || this.search_start_date == undefined){
      this.search_start_date = moment().subtract(1, 'YEARS').format("YYYY-MM-DD");
    }
    this.search_end_date    = this.$session.get("EVENT_END");
    if(this.search_end_date == null || this.search_end_date == undefined){
      this.search_end_date   = moment().format("YYYY-MM-DD");
    }

    if(this.$session.exists("ADMIN_IDX")){
      this.initpage();
    }else{
      //키값 없으면 로그인으로
      this.$router.push("Login");
    }
  },

  data: () => ({
      myChart2: null,
      date1:false,
      date2:false,
      search_start_date : '',
      search_end_date : '',
      checkdate : true,
      list:[],
      sum1:0,
      sum2:0,
      sum3:0,
      sum4:0,
      sum5:0,
      sum6:0,
      sum7:0,
      sum8:0,

      SEARCH_COM_IDX: null,
      SEARCH_COM_NAME: '',
      SEARCH_EVENT_IDX: null,
      SEARCH_EVENT_NAME: '',
      SEARCH_OPTION_IDX: null,
      SEARCH_OPTION_NAME: '',
      grade : 0,

  }),

  methods: {
    

    startDownload(){

      this.$confirm(this.$t('common_downexcel2')).then(() => {

        var templist = [];
        this.list.forEach(item=>{
          templist.push({
            "REG_DATE":item.REG_DATE
          , "CNT1":parseInt(item.CNT1)
          , "CNT2":parseInt(item.CNT2)
          , "COST1":parseInt(item.COST1)
          , "COST2":parseInt(item.COST2)
          , "COST3":parseInt(item.COST3)
          , "COST4":parseInt(item.COST_USD1)
          , "COST5":parseInt(item.COST_USD2)
          , "COST6":parseInt(item.COST_USD3)
          });
        });

        //하단 합계 넣기
        templist.push({
              "REG_DATE":this.$t("chartpayment_col7")
            , "CNT1":this.sum1
            , "CNT2":this.sum2
            , "COST1":this.sum3
            , "COST2":this.sum4
            , "COST3":this.sum5
            , "COST4":this.sum6
            , "COST5":this.sum7
            , "COST6":this.sum8
        });
        
        var item_sheet = XLSX.utils.json_to_sheet(templist);

        //상단 컬럼명 수정
        item_sheet.A1 = {v:this.$t("chartpayment_col6")};
        item_sheet.B1 = {v:this.$t("chartpayment_col1")};
        item_sheet.C1 = {v:this.$t("chartpayment_col2")};
        item_sheet.D1 = {v:this.$t("chartpayment_col3")+"(KRW)"};
        item_sheet.E1 = {v:this.$t("chartpayment_col4")+"(KRW)"};
        item_sheet.F1 = {v:this.$t("chartpayment_col5")+"(KRW)"};
        item_sheet.G1 = {v:this.$t("chartpayment_col3")+"(USD)"};
        item_sheet.H1 = {v:this.$t("chartpayment_col4")+"(USD)"};
        item_sheet.I1 = {v:this.$t("chartpayment_col5")+"(USD)"};

        //컬럼별 너비
        var wscols = [{wch:20},{wch:10},{wch:10},{wch:10,t:'n'},{wch:10,t:'n'},{wch:10,t:'n'},{wch:10,t:'n'},{wch:10,t:'n'},{wch:10,t:'n'}];
        item_sheet['!cols'] = wscols;

        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, item_sheet, this.$t("chartpayment_label2"));
        XLSX.writeFile(wb, this.$t("chartpayment_label3")+Date.now().toString()+'.xlsx');

      });

    },    

    initpage(){

      this.search_run();

    },


    search_run(){

        if(this.grade < 99){
          if(this.SEARCH_EVENT_IDX == null){
            this.$alert(this.$t('common_select_tevent'));
            return;
          }
        }

        if(this.search_start_date.length < 4){
          this.$alert(this.$t('common_search_start_info1'));
          return;
        }
        if(this.search_end_date.length < 4){
          this.$alert(this.$t('common_search_end_info1'));
          return;
        }
        if(this.search_start_date > this.search_end_date){
          this.$alert(this.$t('common_search_date_error1'));
          return;
        }


      this.$http.post(this.$host+'/api/ChartPayment',{
            ADMIN_IDX: this.$session.get("ADMIN_IDX")
          , COM_IDX:   this.SEARCH_COM_IDX == undefined ? '' : this.SEARCH_COM_IDX
          , EVENT_IDX: this.SEARCH_EVENT_IDX == undefined ? '' : this.SEARCH_EVENT_IDX
          , OPTION_IDX: this.SEARCH_OPTION_IDX == undefined ? '' : this.SEARCH_OPTION_IDX
          , CHECKDATE: this.checkdate
          , search_start_date:this.search_start_date == undefined ? '' : this.search_start_date
          , search_end_date:this.search_end_date == undefined ? '' : this.search_end_date
      },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
      .then((result)=>{

        
        this.loading = false;
        
        if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

            //chart.js로 차트를 그린다. 캔버스를 읽어서 차트객체를 만들어주면 알아서 생성된다.
            //const ctx2 = this.$refs.drawarea;

            //캔버스 초기화
            /*
            if(this.myChart2 != null){
              this.myChart2.destroy();
            }
            */
            //ctx2.getContext("2d").clearRect(0, 0, ctx2.width, ctx2.height);

            this.list.splice(0, this.list.length);   //데이터 초기화
            this.list = result.data.resultData;

            this.sum1 = 0;
            this.sum2 = 0;
            this.sum3 = 0;
            this.sum4 = 0;
            this.sum5 = 0;
            this.sum6 = 0;
            this.sum7 = 0;
            this.sum8 = 0;

            if(this.checkdate){
              
              const datanames = [];
              const cost1 = []; //결제
              const cost2 = []; //환불
              const cost3 = []; //결제(달러)
              const cost4 = []; //환불(달러)
              this.list.slice().reverse().forEach(element => {
                datanames.push(element.REG_DATE);
                cost1.push(element.COST1);
                cost2.push(element.COST2);
                cost3.push(element.COST_USD1);
                cost4.push(element.COST_USD2);
                this.sum1 += parseInt(element.CNT1);
                this.sum2 += parseInt(element.CNT2);
                this.sum3 += parseInt(element.COST1);
                this.sum4 += parseInt(element.COST2);
                this.sum5 += parseInt(element.COST3);
                this.sum6 += parseInt(element.COST_USD1);
                this.sum7 += parseInt(element.COST_USD2);
                this.sum8 += parseInt(element.COST_USD3);

              });

              // eslint-disable-next-line no-unused-vars
              const datas = {
                labels:datanames, //차트 하단에 표시됨
                datasets:[
                    {label:this.$t("chartpayment_label4")+'KRW', data:cost1, backgroundColor: 'rgba(9, 156, 253, 0.5)',borderColor: 'rgb(9, 156, 253)', lineTension:0.3, fill: false,}
                  , {label:this.$t("chartpayment_label5")+'KRW', data:cost2, backgroundColor: 'rgba(255, 67, 107, 0.5)',borderColor: 'rgb(255, 67, 107)', lineTension:0.3, fill: false,}
                  , {label:this.$t("chartpayment_label4")+'USD', data:cost3, backgroundColor: 'rgba(255, 67, 107, 0.5)',borderColor: 'rgb(255, 67, 107)', lineTension:0.3, fill: false,}
                  , {label:this.$t("chartpayment_label5")+'USD', data:cost4, backgroundColor: 'rgba(255, 67, 107, 0.5)',borderColor: 'rgb(255, 67, 107)', lineTension:0.3, fill: false,}
                ],
              };

              // eslint-disable-next-line no-unused-vars
              const options = {
                plugins: {
                    datalabels: {
                      color: '#ff0000'
                    },           
                    title: {
                        display: true,
                        text: this.$t("chartpayment_label2")
                    },              
                    legend: { 
                        position: 'right' 
                    },
                    tooltips: {
                        mode: 'index',
                        intersect: false,
                        callbacks: {
                          label: function(tooltipItem, tdata) {
                            var value1 = tdata.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                            return parseInt(value1).toLocaleString();
                          }
                        }
                    },
                },                
                hover: {
                    mode: 'nearest',
                    intersect: true
                },
                scales: {
                    xAxes: [{
                        display: true,
                        ticks:{reverse:true},
                        scaleLabel: {
                            display: true,
                            labelString: this.$t("chartpayment_label6")
                        }
                    }],
                    yAxes: [{
                        display: true,
                        ticks: {
                            suggestedMin: 0,
                        },
                        scaleLabel: {
                            display: true,
                            labelString: this.$t("chartpayment_label7")
                        }
                    }]
                },    
                responsive: true,
                maintainAspectRatio: true,
                aspectRatio : 3
              };     

              //차트 객체에는 캔버스 객체와 타입, 데이터, 옵션이 들어간다.
              //eslint-disable-next-line no-unused-vars
              //this.myChart2 = new Chart(ctx2, {type:'bar', data:datas, options: options});

            }else{

              const cost  = []; //접수
              const cost2 = []; //접수
              cost.push(result.data.resultData[0].COST1);
              cost.push(result.data.resultData[0].COST2);
              cost.push(result.data.resultData[0].COST3);
              this.sum1 = parseInt(result.data.resultData[0].CNT1);
              this.sum2 = parseInt(result.data.resultData[0].CNT2);
              this.sum3 = parseInt(result.data.resultData[0].COST1);
              this.sum4 = parseInt(result.data.resultData[0].COST2);
              this.sum5 = parseInt(result.data.resultData[0].COST3);

              cost2.push(result.data.resultData[0].COST_USD1);
              cost2.push(result.data.resultData[0].COST_USD2);
              cost2.push(result.data.resultData[0].COST_USD3);
              this.sum6 = parseInt(result.data.resultData[0].COST_USD1);
              this.sum7 = parseInt(result.data.resultData[0].COST_USD2);
              this.sum8 = parseInt(result.data.resultData[0].COST_USD3);

              // eslint-disable-next-line no-unused-vars
              const datas = {
                labels:[
                    this.$t("chartpayment_label8")+"KRW"+this.priceToString(result.data.resultData[0].COST1),this.$t("chartpayment_label9")+this.priceToString(result.data.resultData[0].COST2),this.$t("chartpayment_label10")+this.priceToString(result.data.resultData[0].COST3)
                  , this.$t("chartpayment_label8")+"USD"+this.priceToString(result.data.resultData[0].COST_USD1),this.$t("chartpayment_label9")+this.priceToString(result.data.resultData[0].COST_USD2),this.$t("chartpayment_label10")+this.priceToString(result.data.resultData[0].COST_USD3)
                ],
                datasets:[
                    { data:cost, backgroundColor: ['rgba(9, 156, 253, 0.5)', 'rgb(255, 67, 107)', 'rgb(129, 66, 255)'], borderColor: ['rgba(9, 156, 253, 0.5)', 'rgb(255, 67, 107)', 'rgb(129, 66, 255)']}
                  , { data:cost2, backgroundColor: ['rgba(9, 156, 253, 0.5)', 'rgb(255, 67, 107)', 'rgb(129, 66, 255)'], borderColor: ['rgba(9, 156, 253, 0.5)', 'rgb(255, 67, 107)', 'rgb(129, 66, 255)']}
                ],
              };

              // eslint-disable-next-line no-unused-vars
              const options = {
                title: {
                    display: true,
                    text: this.$t("chartpayment_label2")
                },         
                tooltips: {
                    mode: 'index',
                    intersect: false,
                    callbacks: {
                      label: function(tooltipItem, tdata) {
                        var value1 = tdata.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                        return parseInt(value1).toLocaleString();
                      }
                    }
                },
                scales: {
                    xAxes: [{
                        display: false,
                        scaleLabel: {
                            display: false,
                            labelString: this.$t("chartpayment_label6")
                        }
                    }],
                    yAxes: [{
                        display: false,
                        ticks: {
                            suggestedMin: 0,
                            beginAtZero:true,
                        },
                        scaleLabel: {
                            display: false,
                            labelString: this.$t("chartpayment_label7")
                        }
                    }]
                },    
                responsive: true,
                maintainAspectRatio: false
              };     
              
              //eslint-disable-next-line no-unused-vars
              //this.myChart2 = new Chart(ctx2, {type:'pie', data:datas, options: options});

            }

        }else if(result.data.resultCode == 2){
          //로그인 필요
          this.$alert(this.$t("common_tokener"));
          this.$session.clear("ADMIN_IDX");
          this.$session.clear("COM_IDX");
          this.$session.clear("ACNT_IDX");
          this.$session.clear("GRADE");
          this.$session.clear("COM_NAME");
          this.$session.clear("ACCESSTOKEN");
          this.$session.clear("REFLASHTOKEN");
          this.$router.push('Login');   //로그인 페이지로 이동

        }
      })
      // eslint-disable-next-line no-unused-vars
      .catch((error)=>{
        this.loading = false;
        if(error.message == 'Request failed with status code 429')
        {
          this.$alert(this.$t("common_reqer"));
        }else{
          this.$alert(error.message);
        }
      });

    },

    priceToString(price) {
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },


    //입장료 옵션 선택 콜백
    optionsearchcb(val1){
      if(val1.NAME.length > 0){
        this.SEARCH_OPTION_NAME = val1.NAME;
        this.SEARCH_OPTION_IDX  = val1.IDX;
        this.$session.set("OPTION_IDX", val1.IDX);
        this.$session.set("OPTION_NAME",val1.NAME);
      }else{
        this.SEARCH_OPTION_NAME = "";
        this.SEARCH_OPTION_IDX  = null;
        this.$session.set("OPTION_IDX", null);
        this.$session.set("OPTION_NAME", "");
      }
      this.search_run();
    },

    //검색조건 업체 설정
    eventsearchcb(val1){
      if(val1.NAME.length > 0){
        this.SEARCH_EVENT_NAME = val1.NAME;
        this.SEARCH_EVENT_IDX  = val1.IDX;
        this.SEARCH_OPTION_IDX = null;
        this.SEARCH_OPTION_NAME = '';
        this.$session.set("EVENT_IDX", val1.IDX);
        this.$session.set("EVENT_NAME",val1.NAME);
        this.$session.set("OPTION_IDX", null);
        this.$session.set("OPTION_NAME",'');

        this.search_start_date = moment(val1.EVENT_START, "YYYY-MM-DD").format("YYYY-MM-DD");
        this.search_end_date  = moment(val1.EVENT_END, "YYYY-MM-DD").format("YYYY-MM-DD");
        this.$session.set("EVENT_START", this.search_start_date);
        this.$session.set("EVENT_END", this.search_end_date);

      }else{
        this.SEARCH_EVENT_IDX = null;
        this.SEARCH_EVENT_NAME = "";
        this.SEARCH_OPTION_IDX = null;
        this.SEARCH_OPTION_NAME = '';
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.$session.set("OPTION_IDX", null);
        this.$session.set("OPTION_NAME",'');

        this.$session.set("EVENT_START", null);
        this.$session.set("EVENT_END", null);

      }
      this.search_run();
    },

    // eslint-disable-next-line no-unused-vars
    comsearchclear(var2){
        this.SEARCH_COM_IDX    = null;
        this.SEARCH_COM_NAME   = '';
        this.SEARCH_EVENT_IDX  = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("COM_IDX",  null);
        this.$session.set("COM_NAME", "");
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.search_run();
    },

    //업체선택 콜백
    comdialogcb(val){
      if(val.NAME.length > 0){
        this.editedItem.COM_NAME = val.NAME;
        this.editedItem.COM_IDX  = val.IDX;
      }else{
        this.$alert(this.$t('common_select_company'));
        return;
      }
    },

    //검색조건 업체 설정
    comsearchcb(val1){
      if(val1.NAME.length > 0){
        this.SEARCH_COM_NAME = val1.NAME;
        this.SEARCH_COM_IDX  = val1.IDX;
        this.$session.set("COM_IDX", val1.IDX);
        this.$session.set("COM_NAME", val1.NAME);
        this.SEARCH_EVENT_IDX = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
      }else{
        this.SEARCH_COM_NAME = '';
        this.SEARCH_COM_IDX  = null;
        this.SEARCH_EVENT_IDX = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("COM_IDX",  null);
        this.$session.set("COM_NAME", "");
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
      }
      this.search_run();
    },



  }
    
}

</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>

</style>